import {load} from '@shopify/theme-sections';
import '../styles/theme.scss';
import 'preact/devtools';
import React from 'react';
import ReactDOM from 'react-dom';
import SmoothScroll from 'smooth-scroll';
import customSelect from 'custom-select';

import initQuantitySelector from './components/qty-selector';
import SideCart from './components/SideCart';
import accordions from './components/accordions';
import Modals from './components/modal';
import './components/web-vitals';
import fadeInPage from './components/fader';
import currencySelect from './components/currency-select';
import initProductQuickAdd from './components/product-quickadd';
import 'what-input';
import 'lazyvids';
import 'van11y-accessible-tab-panel-aria';

import './sections/announcement';
import './sections/header';
import './sections/hero-banner';
import './sections/hero-slider';
import './sections/featured-articles';
import './sections/featured-collections';
import './sections/featured-icons';
import './sections/image-node';
import './sections/testimonial-carousel';
import './sections/video-text';
import './sections/product-how-to-use';
import './sections/contact';

const ecommerceEnable = window.theme.ecommerce || false;

document.addEventListener('DOMContentLoaded', function () {
  // Redirect for reset password - checks for cookie set below
  const cks = document.cookie.split(';');
  for (let i = 0; i < cks.length; i++) {
    const parts = cks[i].split('=');
    if (parts[0].indexOf('logoutredirecturl') !== -1) {
      document.cookie = `${parts[0]}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
      window.location.replace(parts[1]);
    }
  }

  load('*');

  accordions();

  Modals();

  fadeInPage();

  currencySelect();

  initQuantitySelector();

  hideRechargeIfNotAU();

  initProductQuickAdd();

  // eslint-disable-next-line no-unused-vars
  const smoothScroll = new SmoothScroll('a[href*="#"]', {
    header: '.header',
    durationMin: 600,
    durationMax: 600,
    offset: 30,
  });

  const selectEls = document.querySelectorAll('[data-custom-select]');
  if (selectEls && selectEls.length > 0) {
    customSelect('[data-custom-select] select');
    selectEls.forEach((selectEl) => {
      selectEl.classList.add('appear-in');
    });
  }

  // Add wrapping div to tables in RTE
  const rteTables = document.querySelectorAll('.rte table');
  if (rteTables.length > 0) {
    rteTables.forEach((item) => {
      const wrapper = document.createElement('div');
      wrapper.classList.add('rte__table-wrapper');
      item.parentNode.insertBefore(wrapper, item);
      wrapper.appendChild(item);
    });
  }

  // Sets a cookie to redirect to reset password, which is triggered above
  const passwordRedirectLink = document.querySelector('.password-redirect');
  if (passwordRedirectLink) {
    passwordRedirectLink.addEventListener('click', () => {
      const now = new Date();
      const expiresDate = new Date(now.getTime() + 30000);
      document.cookie = `logoutredirecturl=/account/login#recover;expires=${expiresDate.toGMTString()};path=/`;
    });
  }

  if (typeof Shopify === 'undefined') {
    window.Shopify = {};
  }
  // Get from cart.js returns the cart in JSON
  if (typeof Shopify.getCart === 'undefined') {
    Shopify.getCart = function (callback, cartItems) {
      if (cartItems) {
        if (typeof callback === 'function') {
          callback(cartItems);
        } else if (typeof Shopify.onCartUpdate === 'function') {
          Shopify.onCartUpdate(cartItems);
        }
      } else {
        return window.jQuery.getJSON('/cart.js', function (cart, textStatus, xhr) {
          if (typeof callback === 'function') {
            callback(cart, textStatus, xhr);
          } else {
            Shopify.onCartUpdate(cart);
          }
        });
      }
    };
  }
});

if (ecommerceEnable) {
  ReactDOM.render(<SideCart />, document.getElementById('side-cart-app'));
}

// Detect if touch device by setting a global variable on first touch;
window.addEventListener(
  'touchstart',
  function onFirstTouch() {
    window.userIsTouching = true;
    window.removeEventListener('touchstart', onFirstTouch, false);
  },
  false
);

async function hideRechargeIfNotAU() {
  if (!window.theme?.reCharge?.enabled || !window.theme.reCharge.hideFromCountryCodes) return;
  const hideSelectorOnPDP = () => {
    const rechargeWidgets = document.querySelectorAll('#rc_container');
    if (!rechargeWidgets) return;
    rechargeWidgets.forEach((inputGroup) => {
      const allPurchaseTypeInputs = Array.from(inputGroup.querySelectorAll('input[type="radio"]'));
      const subscriptionOptionInputs = allPurchaseTypeInputs.filter((input) => input.value !== 'onetime');
      if (!subscriptionOptionInputs.length) return;
      subscriptionOptionInputs.forEach((input) => {
        input.parentElement.style.display = 'none';
      });
    });
  };

  try {
    const response = await fetch(`${window.Shopify.routes.root}browsing_context_suggestions.json`);
    const responseJSON = await response.json();
    const storeCountryCode = window.theme.reCharge.storeCountryCode;
    const userCountryCode = responseJSON.detected_values?.country?.handle;
    const codesToHideFrom = window.theme.reCharge.hiddenCountryCodes;
    if (
      codesToHideFrom.includes(userCountryCode) ||
      (codesToHideFrom.length === 0 && userCountryCode !== storeCountryCode)
    ) {
      hideSelectorOnPDP();
    }
  } catch (err) {
    window.console.log(err);
  }
}
